export const reduceCustomerInfo = <T>(info: T, fetchSource: any): T => {
    return Object.keys(info).reduce<T>(
        (previous: T, curr: string) => ({ ...previous, [curr]: fetchSource[curr] }),
        info
    );
};
